import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InitializationService } from 'src/app/services/initialization.service';
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
  selector: 'app-order-sent',
  templateUrl: './order-sent.component.html',
  styleUrls: ['./order-sent.component.scss']
})
export class OrderSentComponent implements OnInit 
{
  constructor(
    private initializationservice:InitializationService, 
    private route: ActivatedRoute, 
    private router:Router,
    private navigationservice:NavigationService
  ) { }

  ngOnInit(): void 
  {
    var appname = String(this.route.snapshot.paramMap.get('appname'));

    if(!this.initializationservice.checkApp(appname))
    {
      this.initializationservice.reloadApp(appname);

      return;
    }
  }

  seeOrderHistory()
  {
    var appname = String(this.route.snapshot.paramMap.get('appname'));

    this.router.navigateByUrl('/' + appname + "/myprofile", { replaceUrl:true });
  }

  back()
  {
    this.navigationservice.back();
  }
}
